import { type RuntimeControlId } from 'owa-ribbon-ids/lib/actionControlId';

export function isReadPinnedAppRuntimeControl(id: number): boolean {
    return id >= 90500 && id < 91000;
}
